import apiBase from "../../api/axios";

const BASE = "v1/talentos-plantel";

const qs = (params = {}) => {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`);
  return parts.length ? `?${parts.join("&")}` : "";
};

// ============================================================
// FRASES PLANTEL
// ============================================================

export const getFrasesPlantelService = async ({
  page = 1, search = "", plantel, tipo_fortaleza, is_active,
} = {}) => {
  const r = await apiBase.get(
    `${BASE}/preguntas-talento-frases/${qs({ page, search, plantel, tipo_fortaleza, is_active })}`
  );
  return r.data;
};

export const createFrasePlantelService = async (payload) => {
  const r = await apiBase.post(`${BASE}/preguntas-talento-frases/`, payload);
  return r.data;
};

export const updateFrasePlantelService = async (id, payload) => {
  const r = await apiBase.put(`${BASE}/preguntas-talento-frases/${id}/`, payload);
  return r.data;
};

export const toggleFrasePlantelActiveService = async (id) => {
  const r = await apiBase.post(`${BASE}/preguntas-talento-frases/${id}/toggle_active/`);
  return r.data;
};

export const getFrasesPlantelSelectorService = async ({ plantel, tipo_fortaleza, search = "" } = {}) => {
  const r = await apiBase.get(
    `${BASE}/selectores/preguntas-talento-frases/${qs({ plantel, tipo_fortaleza, search })}`
  );
  return r.data;
};

// ============================================================
// SUB-FRASES PLANTEL
// ============================================================

export const getSubFrasesPlantelService = async ({
  page = 1, search = "", plantel, frase, talento, tipo_fortaleza, tipo, is_active,
} = {}) => {
  const r = await apiBase.get(
    `${BASE}/preguntas-talento-sub-frases/${qs({ page, search, plantel, frase, talento, tipo_fortaleza, tipo, is_active })}`
  );
  return r.data;
};

export const createSubFrasePlantelService = async (payload) => {
  const r = await apiBase.post(`${BASE}/preguntas-talento-sub-frases/`, payload);
  return r.data;
};

export const updateSubFrasePlantelService = async (id, payload) => {
  const r = await apiBase.put(`${BASE}/preguntas-talento-sub-frases/${id}/`, payload);
  return r.data;
};

export const toggleSubFrasePlantelActiveService = async (id) => {
  const r = await apiBase.post(`${BASE}/preguntas-talento-sub-frases/${id}/toggle_active/`);
  return r.data;
};
